import type { Feature } from 'geojson';
import { featureUtil } from 'utils/geoJSONFeatureUtils/featureUtil';

import useFeatureOutline from 'components/Map/hooks/useFeatureOutline';
import { GEOJSON_PROPERTY } from 'components/Map/hooks/useFeatures/constants';
import useTextBox from 'components/Map/hooks/useTextBox';

import { OutlineMode } from './constants';
import type { Props } from './types';

const useBoundingBox = ({ outlineMode = OutlineMode.GEOMETRY_OUTLINE }: Props = {}) => {
    const { removeFeatureOutline, upsertFeatureOutline } = useFeatureOutline();

    const { removeTextBox, upsertTextBox } = useTextBox();

    const upsertBoundingBox = (feature: Feature) => {
        const boundingBoxFeatureOutline = upsertFeatureOutline(feature, outlineMode);
        const outlineCoordinates = boundingBoxFeatureOutline.geometry.coordinates;
        const result = featureUtil.getNorthmostLinePlacement(outlineCoordinates, feature);

        if (!result.success) {
            console.error(
                'upsertBoundingBox: skipping textbox upsert —',
                result.reason,
                feature.id
            );

            return;
        }

        const name = feature.properties?.[GEOJSON_PROPERTY.NAME];

        if (name) {
            upsertTextBox(feature, result.placement.position, name, result.placement.rotation);
        }
    };

    const removeBoundingBox = (featureId: string) => {
        removeFeatureOutline(featureId);
        removeTextBox(featureId);
    };

    return {
        removeBoundingBox,
        upsertBoundingBox
    };
};

export default useBoundingBox;
